<template>
  <div class="container-fluid">
    <div >
      <b-navbar fixed="top">
        <b-navbar-nav>
          <table>
            <tr>
              <td>
                <b-nav-item @click="goToTop" class="b-nav-item"><b style="color: white"><b-icon-arrow-up></b-icon-arrow-up> </b></b-nav-item>
              </td>
            </tr>
            <tr>
              <td>
                <b-nav-item @click="goToPage1" class="b-nav-item"><b style="color: white">1</b></b-nav-item>
              </td>
            </tr>
            <tr>
              <td>
                <b-nav-item @click="goToPage2" class="b-nav-item"><b style="color: white">2</b></b-nav-item>
              </td>
            </tr>
            <tr>
              <td>
                <b-nav-item @click="goToPage3" class="b-nav-item"><b style="color: white">3</b></b-nav-item>
              </td>
            </tr>
            <tr>
              <td>
                <b-nav-item @click="goToDown" class="b-nav-item"><b style="color: white"><b-icon-arrow-down></b-icon-arrow-down></b></b-nav-item>
              </td>
            </tr>
          </table>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import DFooter from "@/components/Footer";
export default {
  name: "NavBar",
  computed: {
    ...mapState({
      form: state => {
        return state.Eventform.form;
      },
    }),
  },
    methods: {
      goToPage1() {
        let data = {
          id: this.form.id
        }
        this.$store.dispatch("Eventform/onGetCaseID", data);
        this.$store.dispatch("Eventform/onGetAppearancesID", data);
        this.$store.dispatch("Eventform/onGetTransformationID", data)
        // this.$store.dispatch("Eventform/onGetTransformationID",data)
        console.log("goToNextPage")
        const path = `/question-form/1`
        if (this.$route.path !== path) this.$router.push(path)
      },
      goToPage2() {
        let data = {
          id: this.form.id
        }
        this.$store.dispatch("Eventform/onGetCaseID", data);
        this.$store.dispatch("Eventform/onGetAppearancesID", data);
        this.$store.dispatch("Eventform/onGetTransformationID", data)
        // this.$store.dispatch("Eventform/onGetTransformationID",data)
        console.log("goToNextPage")
        const path = `/question-form/2`
        if (this.$route.path !== path) this.$router.push(path)
      },
      goToPage3() {
        let data = {
          id: this.form.id
        }
        this.$store.dispatch("Eventform/onGetCaseID", data);
        this.$store.dispatch("Eventform/onGetAppearancesID", data);
        this.$store.dispatch("Eventform/onGetTransformationID", data)
        // this.$store.dispatch("Eventform/onGetTransformationID",data)
        console.log("goToNextPage")
        const path = `/question-form/3`
        if (this.$route.path !== path) this.$router.push(path)
      },
      goToTop(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      },
      goToDown(){
        document.body.scrollTo(0, 10000);
        document.documentElement.scrollTo(0, 10000);
      }
    }
}
</script>

<style lang="css" scoped>
.b-nav-item{
  color: white;
  background: #17a2b8;
  border-radius: 30px;
  text-align: center;

}
table{
  position:fixed;
  right:10px;
  top: 40%;

}
</style>
